import { useMemo } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { groupLocationsByTown, useActiveLocations } from "./locationGroups";

// Mobile menu version of LocationDropdown: the same locations, grouped by town.
const LocationLinks = ({ onNavigate }) => {
  const locations = useActiveLocations();
  const groups = useMemo(() => groupLocationsByTown(locations || []), [locations]);

  return (
    <div className="w-full text-left">
      <h3 className="mb-3 border-b border-amber-400 pb-2 text-lg font-semibold text-slate-300">
        S'inscrire aux hebdos
      </h3>

      {!locations ? (
        <div className="space-y-2">
          {[0, 1, 2].map((i) => (
            <div key={i} className="h-9 animate-pulse rounded-lg bg-white/10" />
          ))}
        </div>
      ) : (
        <div className="space-y-3 text-sm">
          {groups.map((group) => (
            <section key={group.town} aria-label={group.town}>
              <p className="mb-0.5 flex items-center gap-1.5 px-3 text-[11px] font-bold uppercase tracking-wider text-amber-300">
                <MapPin size={12} strokeWidth={2.5} />
                {group.town}
              </p>
              <div>
                {group.locations.map((loc) => (
                  <Link
                    key={loc.id}
                    to={`/locations/${loc.id}`}
                    onClick={onNavigate}
                    className="flex items-center gap-2 rounded-lg px-3 py-2 font-medium text-white transition hover:bg-white/10 active:bg-amber-500"
                  >
                    <span className="min-w-0 flex-1 leading-snug">
                      {loc.name || loc.id}
                      {loc.sharedName && loc.table && (
                        <span className="font-normal text-slate-300"> · {loc.table}</span>
                      )}
                    </span>
                  </Link>
                ))}
              </div>
            </section>
          ))}
        </div>
      )}
    </div>
  );
};

export default LocationLinks;
